import { useState, useEffect, useRef } from "react";
import * as axios from "axios";
import { ArticleExtraData } from "../../../../../articlePage/stateInterfaces";
import { ToggleSwitch } from "../../../../commonComponents/inline/toggleSwitch/toggleSwitch";
import { getTranslation } from "../../autoTickerRowWidget/autoTickerRowTranslations";
import { FlashPageSpecialItem } from "./flashPageSpecialItem";
import { addAxiosDateTransformerSettings } from "../../../../../utils/network/axiosDateTransformer";

interface accordionProps {
    isLTR: boolean
    languageCode: string
    items: ArticleExtraData[]
    roofOngoingEvent: boolean
    tabBackgroundColor: string
    componentaId: string
    commercialBannerId: string
    commercialItemsNum: number
    commercialRepetitionsNum: number
}

export const FlashPageSpecialComponent = (props: accordionProps) => {

    const { items: initialItems, languageCode, isLTR, roofOngoingEvent, tabBackgroundColor, componentaId, commercialItemsNum, commercialRepetitionsNum, commercialBannerId } = props;
    const [items, setItems] = useState<ArticleExtraData[]>(initialItems);
    const [openedItemIndex, setOpenedItemIndex] = useState<string | null>(getSharedItem() || null);
    const [typeOfView, setTypeOfView] = useState<string>("regular");
    const [openedItems, setOpenedItems] = useState<string[]>([]);
    const intervalRef: any = useRef(null); 

    const lang = languageCode ? languageCode.slice(0, 2) : "he";

    useEffect(() => {
        setItems(initialItems); 
    }, [initialItems]);

    useEffect(() => {
        intervalRef.current = setInterval(() => {
            fetchTickerArticles();
        }, 60000);

        return () => {
            if (intervalRef.current) {
                clearInterval(intervalRef.current);
            }
        };
    }, []);

    const fetchTickerArticles = () => {
        const axiosInstance = axios.create(addAxiosDateTransformerSettings());

        axiosInstance.get(`/iphone/json/api/auto_ticker/${componentaId}`)
            .then((res: any) => {
                setItems(res.data.data);
            })
            .catch(err => console.error("error getting ticker data:", err));
    };

    const openItem = (id: string) => {
        setOpenedItems([...openedItems, id])
    }

    const closeItem = (id: string) => {

        let newOpenedItems = openedItems.filter(item => item !== id);
        setOpenedItems(newOpenedItems);
    }

    const itemToggle = (i: number) => {
        if (typeOfView === "expanded") {
            const idx = openedItems.findIndex(id => id === items[i].articleId);
            const articleId = items[i].articleId;
            (idx !== -1) ? closeItem(articleId) : openItem(articleId)
        } else {
            if (items[i].articleId === openedItemIndex) {
                setOpenedItemIndex(null)
            } else {
                setOpenedItemIndex(items[i].articleId)
            }
        }
    }

    const onSwitchChange = () => {
        if (typeOfView === "regular") {
            setTypeOfView("expanded")
            const allIds = items.map(item => item.articleId)
            const missing = allIds.filter(id => !openedItems.includes(id))
            setOpenedItems([...openedItems, ...missing])
        } else if (typeOfView === "expanded") {
            setTypeOfView("regular")
            setOpenedItems([])
        }
    }

    return (
        <div className="flash-page-special-component">
            <div className="flash-page-special-tab" style={{ backgroundColor: tabBackgroundColor }}>
                <div className="tab-title">
                    <div className="tab-icon"></div>

                    <div className="tab-text">{getTranslation(lang, "News Flash")}</div>
                </div>

                <div className="display-mode-toggle" >
                    <div className="toggle-title" onClick={onSwitchChange}>{getTranslation(lang, "ExtendedView")}</div>

                    <ToggleSwitch checked={typeOfView === "expanded"} onSwitchPressed={onSwitchChange} />
                </div>
            </div>

            <div className="slotList">
                {(() => {
                    let visibleItems = [];
                    const itemList = items;
                    const itemLength = itemList.length;
                    
                    // Add all items first
                    for (let i = 0; i < itemLength; i++) {
                        const previousRoof = i > 0 ? (itemList[i - 1] as ArticleExtraData).roof : null;
                        const nextRoof = i < itemList.length - 1 ? (itemList[i + 1] as ArticleExtraData).roof : null;
                        
                        visibleItems.push(
                            <FlashPageSpecialItem
                                index={i}
                                isLTR={isLTR}
                                article={itemList[i]}
                                nextRoof={nextRoof}
                                key={itemList[i].articleId}
                                previousRoof={previousRoof}
                                languageCode={languageCode}
                                roofOngoingEvent={roofOngoingEvent}
                                accordionOpenState={itemList[i].articleId === openedItemIndex || openedItems.includes(itemList[i].articleId)}
                                onToggle={() => itemToggle(i)}
                            />
                        );
                    }
                    
                    // Insert Taboola items if needed
                    if (itemLength > 0 && commercialItemsNum > 0 && commercialRepetitionsNum > 0) {
                        const availableRepetitions = Math.floor(itemLength / commercialItemsNum);
                        const numberOfTaboolaItems = availableRepetitions < commercialRepetitionsNum ? availableRepetitions : commercialRepetitionsNum;
                        
                        for (let i = 0; i < numberOfTaboolaItems; i++) {
                            visibleItems.splice(commercialItemsNum * (i + 1) + i, 0, <div id={`${commercialBannerId}.${i + 1}`} />);
                        }
                    }
                    
                    return visibleItems;
                })()}
            </div>
        </div>
    )
}

FlashPageSpecialComponent.siteScriptName = "FlashPageSpecialComponent"

const getSharedItem = (): string => {
    const url = typeof window !== "undefined" ? window.location.href : "";
    const urlSliceIndex = url.indexOf("#")
    if (urlSliceIndex !== -1) {
        return url.slice(urlSliceIndex + 1)
    }
    return ""
}